module.exports = __webpack_public_path__ + "static/media/ussunnah.95026e69.svg";